import type { FC } from "react";
import styled from "styled-components";
import type { IEnrichedIndustry } from "app/pages/industry-analysis/home/enriched-custom-industries/types";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { Visits } from "app/pages/industry-analysis/home/enriched-custom-industries/TrafficAndEngagementData/Visits";
import { PeriodChange } from "app/pages/industry-analysis/home/enriched-custom-industries/TrafficAndEngagementData/PeriodChange";
import { Loader } from "app/pages/industry-analysis/home/enriched-custom-industries/TrafficAndEngagementData/Loader";
import { hasEnrichedCustomIndustryPermission } from "app/pages/industry-analysis/home/enriched-custom-industries/hasEnrichedCustomIndustryPermission";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";

interface ITrafficAndEngagementData {
    industry: IEnrichedIndustry;
    isLoading: boolean;
}

const Container = styled(FlexRow)`
    width: 170px;
    gap: 24px;
`;

export const TrafficAndEngagementData: FC<ITrafficAndEngagementData> = (props) => {
    const { industry, isLoading } = props;
    const { visits, periodChange } = industry;
    return (
        <Container>
            {!hasEnrichedCustomIndustryPermission() || CategoryServiceUtils.hasSegments(industry) ? null : isLoading ? (
                <Loader />
            ) : (
                <>
                    <Visits visits={visits} />
                    <PeriodChange periodChange={periodChange} />
                </>
            )}
        </Container>
    );
};
